import { inject } from '@angular/core';
import { Observable, take, map, withLatestFrom } from 'rxjs';
import { ActivatedRouteSnapshot, Route, UrlSegment } from '@angular/router';

import { CanActivateFn, CanMatchFn } from '@shared/models/guard';
import { RoutingService, UserRightsService } from '@shared/services';
import { UserDetailsFacade } from '@shared/state/facades';

export const canActivateSubprojectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean> => {
  const targetRoute = getClassifiedTargetRoute(route.url);
  return hasSubprojectIdAndRights(targetRoute);
};

export const canMatchSubprojectGuard: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[]
): Observable<boolean> => {
  const targetRoute = getClassifiedTargetRoute(segments);
  return hasSubprojectIdAndRights(targetRoute);
};

const getClassifiedTargetRoute = (segments: UrlSegment[]): string => {
  const urlSegments = segments.map((x) => x.path);
  if (urlSegments.includes('dprs')) {
    return 'dprs';
  }

  if (urlSegments.includes('project-setup')) {
    return 'project-setup';
  }

  return 'dprs';
};

const hasSubprojectIdAndRights = (targetRoute: string): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);
  const userRightsService = inject(UserRightsService);
  const routingService = inject(RoutingService);

  return userDetailsFacade.query.selectedSubprojectId$.pipe(
    withLatestFrom(userDetailsFacade.query.userDetails$),
    take(1),
    map(([subprojectId, userDetails]) => {
      if (
        !subprojectId ||
        !userRightsService.hasRightsForSubprojectState(
          targetRoute,
          subprojectId,
          userDetails
        )
      ) {
        routingService.goToFirstAllowedRoute(userDetails, subprojectId);
        return false;
      }
      return true;
    })
  );
};
